import { useCallback, useEffect, useRef } from "react";
import { bestaetigen as meBestaetigen } from "../me/index.js";
/** Die Fragen, die `bestaetigen()` von me-design baut, tragen dieses Kennzeichen. */
const FRAGE = "me-dialog[data-bestaetigen]";
function aktivesElement() {
    const aktiv = document.activeElement;
    return aktiv === null || aktiv === document.body ? null : aktiv;
}
export function useBestaetigung() {
    const offenRef = useRef(null);
    const frageStellen = useCallback((frage, mitText, feld = {}) => {
        if (offenRef.current !== null)
            return Promise.resolve({ ok: false, text: "" });
        return new Promise((aufloesen) => {
            const eintrag = { dialog: null, aufloesen };
            offenRef.current = eintrag;
            const fertig = (ergebnis) => {
                if (offenRef.current === eintrag)
                    offenRef.current = null;
                aufloesen(ergebnis);
            };
            eintrag.aufloesen = fertig;
            const vorher = new Set(document.querySelectorAll(FRAGE));
            const antwort = meBestaetigen({
                titel: frage.titel,
                ...(frage.text === undefined ? {} : { text: frage.text }),
                bestaetigenText: frage.bestaetigenText,
                ...(frage.abbrechenText === undefined ? {} : { abbrechenText: frage.abbrechenText }),
                ...(mitText ? { begruendung: "freiwillig" } : {}),
                gefahr: frage.gefaehrlich === true,
                an: frage.an === undefined ? aktivesElement() : frage.an,
            });
            // Der Helfer hängt die Frage im selben Aufruf ein — die neue ist die, die vorher fehlte.
            eintrag.dialog = Array.from(document.querySelectorAll(FRAGE))
                .find((d) => !vorher.has(d)) ?? null;
            // me-design kennt keine Beschriftung und keine Höchstlänge des Begründungsfelds (bestaetigen.js:127) — W29.
            const textfeld = mitText ? eintrag.dialog?.querySelector("me-eingabe") : undefined;
            if (feld.begruendungLabel !== undefined)
                textfeld?.setAttribute("beschriftung", feld.begruendungLabel);
            if (feld.maxLaenge !== undefined)
                textfeld?.setAttribute("maxlength", String(feld.maxLaenge));
            void antwort.then(({ ok, begruendung }) => { fertig({ ok, text: begruendung }); }, () => { fertig({ ok: false, text: "" }); });
        });
    }, []);
    const bestaetigen = useCallback((frage) => frageStellen(frage, false).then((e) => e.ok), [frageStellen]);
    const bestaetigenMitText = useCallback((frage) => frageStellen(frage, true, frage), [frageStellen]);
    // Aushängen mit offener Frage: abgelehnt, und die Frage geht mit.
    useEffect(() => () => {
        const offen = offenRef.current;
        offenRef.current = null;
        if (offen === null)
            return;
        offen.aufloesen({ ok: false, text: "" });
        const dialog = offen.dialog;
        if (dialog === null)
            return;
        if (dialog.isConnected && typeof dialog.schliessen === "function")
            dialog.schliessen();
        else
            dialog.remove();
    }, []);
    return { bestaetigen, bestaetigenMitText };
}
//# sourceMappingURL=useBestaetigung.js.map